












































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  UnitsApi, EventNew, MarketsApi,
} from '@compassdigital/foodworks.ts.sdk';
import ToastModule from '@/store/modules/toast';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import UnitList from '@/components/Form/Scheduler/UnitList/index.vue';
import ScheduleUtil from '@/util/ScheduleUtil';
import AppModule from '@/store/modules/app';
import Format from '@/util/Format';
import UnitsUtil from '@/util/UnitUtil';

@Component({
  components: {
    PrimaryButton,
    UnitList,
  },
})
export default class publishUnits extends Vue {
  public monthCalendar: any = '';

  public eventMeta: EventNew[] = [];

  public unitsInMarketID: any = {};

  public saving: boolean = false;

  public unitActiveUser: string = '';

  public publishUnitDate: string = '';

  public eventPartners: EventNew[] = [];

  public error: string = '';

  public start: any = '';

  public end: any = '';

  private isOpen: boolean = false;

  public loading: boolean = false;

  public publishUserCount: boolean = true;

  public disableUnits: boolean = false;

  public eventHiehgt: number = 50;

  public greyOutUsers: any = '';

  public marketID: string = '';

  public mounted() {
    const {
      units, monthDay, publishDate, marketID,
    } = this.$route.params;
    if (units) {
      this.unitsInMarketID = units;
      this.monthCalendar = monthDay;
      this.publishUnitDate = publishDate;
      this.start = publishDate;
      this.end = publishDate;
      this.marketID = marketID;
      this.getUnits();
    }
  }

  public async onChangeUnit(id: any) {
    this.disableUnits = true;
    try {
      this.unitActiveUser = id;
      this.saving = true;
      const startDate = '2020-08-01';
      const endDate: string = '2027-08-01';
      const nullDate: any = undefined;
      const api = new UnitsApi(AppModule.apiConfig);
      const events: any = await api.getUnitEvents(
        id, nullDate, startDate, endDate,
      );
      const publishedUnitsFiltered = ScheduleUtil.getPublishedUnitsEvent(
        events.data, this.publishUnitDate,
      );
      if (publishedUnitsFiltered.length > 0) {
        this.publishUserCount = false;
      } else {
        this.publishUserCount = true;
      }
      this.eventMeta = ScheduleUtil.getMappedEvents(events.data);
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.disableUnits = false;
    this.saving = false;
  }

  public async onSubmitEvents() {
    try {
      this.loading = true;
      const date = Format.getSchedulerDate(this.publishUnitDate);
      const api = new UnitsApi(AppModule.apiConfig);
      const events = await api.publishUnitEvents(
        this.unitActiveUser, date,
      );
      if (events.data) {
        this.publishUserCount = true;
        const message = 'Published accepted events';
        if (message) {
          ToastModule.setToast({
            message: `${message}`,
            timeout: 5000,
          });
        }
        this.getUnits();
        this.onChangeUnit(this.unitActiveUser);
      }
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.loading = false;
  }

  public async getUnits() {
    try {
      this.saving = true;
      this.disableUnits = true;
      const api = new MarketsApi(AppModule.apiConfig);
      const fetchedUnits = await api.getUnitsInMarketId(this.marketID);
      const updateData: any = UnitsUtil.activeUnits(fetchedUnits.data as any);
      this.unitsInMarketID = await ScheduleUtil.getAestrickUnit(
        updateData, this.start,
      );
    } catch (error) {
      const { message } = error.response.data.error;
      if (message) {
        ToastModule.setToast({
          message: `${message}`,
          timeout: 5000,
        });
      }
    }
    this.disableUnits = false;
    this.saving = false;
  }

  public onClosePublishUnit() {
    this.$router.push(`${this.marketID}`);
  }
}
